<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 350 550"
        style="enable-background: new 0 0 350 550"
        xml:space="preserve"
    >
        <g>
            <rect x="0.24" y="524.82" class="st0" width="549.53" height="4.53" />
            <g>
                <rect x="0.24" y="529.36" class="st1" width="549.53" height="7.3" />
            </g>
            <rect x="0.24" y="536.66" class="st2" width="549.53" height="13.34" />
        </g>
        <g>
            <rect x="0.24" y="20.64" class="st0" width="549.53" height="4.53" />
            <g>
                <rect x="0.24" y="13.34" class="st1" width="549.53" height="7.3" />
            </g>
            <rect x="0.24" y="0" class="st2" width="549.53" height="13.34" />
        </g>
    </svg>
</template>
<script>
export default {
    name: "UspaFrame",
};
</script>
<style type="text/css">
.st0 {
    fill: #a32035;
}
.st1 {
    fill: #ffffff;
}
.st2 {
    fill: #12284c;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/asset/UspaFrame.vue